import styled from 'styled-components';

const ArticleCardStyle = styled.div`
  {
    display: inline-block;
    margin-right: 10px;
    height: 289px;
    width: 252px;
    overflow: hidden;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    margin-bottom: 15px;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    white-space: normal;
    &:last-child {
      margin-right: 0;
    }
    .articleImageContainer {
      // display: block;
      width: 252px;
      height: 161px;
      border-radius: 4px 4px 0 0;
      margin-bottom: 8px;
      background-image: url(${props =>
        `${props.imageUrl}?nf_resize=smartcrop&w=252&h=161`
      });
      background-size: cover;
      background-repeat: no-repeat;
      overflow: hidden;
      position: relative;
    }
    .articleTitle {
      display: block;
      display: -webkit-box;
      max-height: 63px;
      margin: 0 15px;
      font-size: 16px;
      font-weight: 700;
      line-height: 21px;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .articleDateAndAuthor {
      font-size: 14px;
      line-height: 16px;
      color: #6f6d6d;
      margin: 15px;
      max-height: 16px;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      .verticalLine {
        margin: 0 5px;
      }
    }
  }

  a {
    text-decoration: none;
    color: #000000;

    display: flex;
    margin-right: 10px;
    height: 289px;
    width: 252px;
    border-radius: 4px;
    flex-direction: column;
    justify-content: space-between;

  }
`;

export default ArticleCardStyle;
